import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

function Footer() {
  const [settings, setSettings] = useState(null);
  const [contact, setContact] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [settingsRes, contactRes] = await Promise.all([
        axiosInstance.get("/api/settings"),
        axiosInstance.get("/api/contact"),
      ]);
      setSettings(settingsRes.data);
      setContact(contactRes.data);
    } catch (err) {
      console.error("Failed to load footer data", err);
    }
  };

  const socialLinks = [
    { url: contact?.facebook_url, icon: "bi-facebook" },
    { url: contact?.instagram_url, icon: "bi-instagram" },
    { url: contact?.youtube_url, icon: "bi-youtube" },
    { url: contact?.twitter_url, icon: "bi-twitter-x" },
  ].filter((s) => s.url);

  return (
    <footer className="bg-dark text-white-50 pt-5 pb-3 mt-auto">
      <div className="container">
        <div className="row g-4">
          <div className="col-12 col-md-4">
            <h5 className="text-white mb-2">
              {settings?.school_name || "School Name"}
            </h5>
            <p className="small mb-1">{settings?.trust_name}</p>
            {contact?.address && <p className="small">{contact.address}</p>}
          </div>

          <div className="col-6 col-md-4">
            <h6 className="text-white mb-3">Quick Links</h6>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <Link to="/" className="text-white-50 text-decoration-none">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/about"
                  className="text-white-50 text-decoration-none"
                >
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/gallery"
                  className="text-white-50 text-decoration-none"
                >
                  Gallery
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-white-50 text-decoration-none"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-4">
            <h6 className="text-white mb-3">Contact</h6>
            <ul className="list-unstyled small">
              {contact?.phone_primary && (
                <li className="mb-2">
                  <i className="bi bi-telephone me-2"></i>
                  {contact.phone_primary}
                </li>
              )}
              {contact?.email && (
                <li className="mb-2">
                  <i className="bi bi-envelope me-2"></i>
                  {contact.email}
                </li>
              )}
            </ul>

            {socialLinks.length > 0 && (
              <div className="d-flex gap-3 mt-3">
                {socialLinks.map((s) => (
                  <a
                    key={s.icon}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white-50 fs-5"
                  >
                    <i className={`bi ${s.icon}`}></i>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <hr className="border-secondary mt-4" />
        <p className="text-center small mb-0">
          © {new Date().getFullYear()} {settings?.school_name || "School Name"}.
          All rights reserved.
          {" · "}
          <Link
            to="/admin/login"
            className="text-white-50 text-decoration-none"
          >
            Admin Login
          </Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
